module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.selectedService && _vm.serviceData(_vm.selectedService).optinAllow && _vm.sharedAllowedTime() && !_vm.isAsap && !_vm.extraStop.length) ? _c('div', {
    staticClass: "card margin-t-s medium-margin-v-s"
  }, [(_vm.rsvpData.isAirportPickup) ? _c('div', {
    staticClass: "availability"
  }, [_vm._v("\n      " + _vm._s(_vm.$t('serviceSelect.availableOnlyFrom')) + " "), _c('b', [_vm._v(_vm._s(_vm.rsvp.optin.sharedAllowedTime.start) + " - " + _vm._s(_vm.rsvp.optin.sharedAllowedTime.end))])]) : _vm._e(), _vm._v(" "), _c('h3', {
    staticClass: "margin-t-z margin-b-z"
  }, [_vm._v("\n      " + _vm._s(_vm.$t('serviceSelect.save')) + " \n      "), _c('b', [_vm._v(_vm._s(_vm.services[_vm.selectedService].optinPercent) + "%")]), _vm._v("\n      " + _vm._s(_vm.$t('serviceSelect.bySharingRide')) + " \n    ")]), _vm._v(" "), _c('div', {
    staticClass: "opt-copy"
  }, [_vm._v("\n      " + _vm._s(_vm.$t('serviceSelect.ifWeFind')) + " \n      "), _c('b', [_vm._v("$" + _vm._s(_vm.optinRefundPrice().toFixed(2)))]), _vm._v("\n      " + _vm._s(_vm.$t('serviceSelect.atTheTime')) + " \n    ")]), _vm._v(" "), _c('div', {
    staticClass: "opt-check"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.enabled),
      expression: "enabled"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.enabled) ? _vm._i(_vm.enabled, null) > -1 : (_vm.enabled)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.enabled,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.enabled = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.enabled = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.enabled = $$c
        }
      }
    }
  }), _vm._v("\n        " + _vm._s(_vm.$t('serviceSelect.iWantTo')) + "\n      ")])])]) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-29f90bd6", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-29f90bd6","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ServiceSelection/OptinShared.vue
// module id = 2061
// module chunks = 0